/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RolePrimeDerivee } from './RolePrimeDerivee';
import {
    RolePrimeDeriveeFromJSON,
    RolePrimeDeriveeFromJSONTyped,
    RolePrimeDeriveeToJSON,
    RolePrimeDeriveeToJSONTyped,
} from './RolePrimeDerivee';

/**
 * Garantie du référentiel, rattachée à une branche. Remplace l'ancienne « garantie produit » : le socle est désormais porté par la branche et non par le produit.
 * @export
 * @interface GarantieReferentielDto
 */
export interface GarantieReferentielDto {
    /**
     * 
     * @type {string}
     * @memberof GarantieReferentielDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GarantieReferentielDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieReferentielDto
     */
    shortLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieReferentielDto
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieReferentielDto
     */
    branchId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieReferentielDto
     */
    branchCode?: string | null;
    /**
     * 
     * @type {RolePrimeDerivee}
     * @memberof GarantieReferentielDto
     */
    derivedPremiumRole: RolePrimeDerivee;
    /**
     * 
     * @type {boolean}
     * @memberof GarantieReferentielDto
     */
    damage?: boolean;
}



/**
 * Check if a given object implements the GarantieReferentielDto interface.
 */
export function instanceOfGarantieReferentielDto(value: object): value is GarantieReferentielDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('derivedPremiumRole' in value) || value['derivedPremiumRole'] === undefined) return false;
    return true;
}

export function GarantieReferentielDtoFromJSON(json: any): GarantieReferentielDto {
    return GarantieReferentielDtoFromJSONTyped(json, false);
}

export function GarantieReferentielDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GarantieReferentielDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'shortLabel': json['shortLabel'] == null ? undefined : json['shortLabel'],
        'label': json['label'] == null ? undefined : json['label'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'branchCode': json['branchCode'] == null ? undefined : json['branchCode'],
        'derivedPremiumRole': RolePrimeDeriveeFromJSON(json['derivedPremiumRole']),
        'damage': json['damage'] == null ? undefined : json['damage'],
    };
}

export function GarantieReferentielDtoToJSON(json: any): GarantieReferentielDto {
    return GarantieReferentielDtoToJSONTyped(json, false);
}

export function GarantieReferentielDtoToJSONTyped(value?: GarantieReferentielDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'shortLabel': value['shortLabel'],
        'label': value['label'],
        'branchId': value['branchId'],
        'branchCode': value['branchCode'],
        'derivedPremiumRole': RolePrimeDeriveeToJSON(value['derivedPremiumRole']),
        'damage': value['damage'],
    };
}

